function s(e, n, t = 1e-9) {
  return Math.abs(e - n) < t;
}
function u(e) {
  let n = 0, t = 0;
  for (const r of e) {
    const o = r - t, c = n + o;
    t = c - n - o, n = c;
  }
  return n;
}
export {
  s as isWithinTolerance,
  u as kahanSum
};
//# sourceMappingURL=index.js.map
